<div class="about-section">
    <div class="container">
        <div class="row align-items-center m-1">
            <!-- Left Side: Text -->
            <div class="col-md-7 col-12 about-text">
                <h2>The Pottery Program</h2>
                <!-- <h3>Diverse Avenues for Discovery and Growth</h3> -->
                <p>
                    The Pottery Program at Innovative Vision is a unique hands-on activity that fosters creativity,
                    focus, and a sense of calm. Through the tactile and artistic process of working with clay, children
                    not only develop their fine motor skills but also nurture their imagination and emotional
                    well-being. This program is an essential part of our holistic approach, addressing the mind, body,
                    and soul in a deeply engaging way.
                </p>
            </div>
            <!-- Right Side: Image -->
            <div class="col-md-5 col-12 text-center about-img">
                <img src="assets/ivimg/programDetails/potteryH.svg" alt="Girl Learning Pottery" class="img-fluid">
            </div>
        </div>
    </div>
</div>
<div class="key-focus-section m-3">
    <div class="image-container">
        <img src="assets/ivimg/programDetails/test.png" alt="Key Focus Areas"/>
    </div>
    <div class="content">
        <h2 class="section-title">Key Focus Areas</h2>
        <div class="points">
            <p>
                <strong>1. Creativity & Imagination:</strong> Pottery provides a direct medium for children to transform
                their ideas into tangible objects. It encourages them to think creatively, experiment with shapes and
                forms, and bring their unique visions to life, which is a powerful way to stimulate the right brain.
            </p>
            <p>
                <strong>2. Focus & Concentration:</strong> The process of centering clay on a pottery wheel and
                meticulously shaping a pot demands immense focus. This practice helps children develop their
                concentration skills and patience, teaching them to be present in the moment and to persevere through
                challenges.
            </p>
            <p>
                <strong>3. Fine Motor Skills & Sensory Development:</strong> Working with clay is an excellent way to
                strengthen a child's fine motor skills and hand-eye coordination. The sensory experience of touching and
                shaping the clay is also deeply calming and grounding, contributing to their emotional well-being.
            </p>
        </div>
    </div>
</div>


<div class="program-highlights">
    <div class="highlight-container">
        <!-- Image from assets -->
        <div class="image-container">
            <img src="assets/ivimg/PD-2.svg" alt="Program Highlights" />
        </div>
        <!-- Text Content -->
        <div class="text-container">
            <h2 class="title">Program Highlights</h2>
            <p>
                <strong>Hands-On Experience: </strong> Our program is completely hands-on, allowing children to learn by
                doing. They get to experience every step of the pottery process, from preparing the clay to creating a
                finished piece.
            </p>
            <p>
                <strong>Calming & Meditative Environment:</strong> The pottery studio is a tranquil space where children
                can unwind and focus on their creations. The rhythmic turning of the wheel and the feel of the clay have
                a therapeutic effect, providing a sense of inner peace.
            </p>
            <p>
                <strong>Expert Guidance:</strong> Our instructors are experienced in both pottery and child development.
                They guide children through the process, encouraging their creativity while ensuring a safe and
                supportive learning environment.
            </p>
        </div>
    </div>
</div>


<div class="benefits-section">
    <h2 class="benefits-title">Benefits for Your Child</h2>
    <p class="benefits-text">
        The pottery program offers a unique blend of creative and developmental benefits. It is a calming and grounding
        experience that helps children improve their focus, patience, and fine motor skills. The process of creating
        something from scratch boosts their self-esteem and provides a positive outlet for self-expression. By engaging
        both the hands and the mind, pottery helps to shape a well-rounded and confident individual, ready to explore
        their creative potential.
    </p>
</div>